export default __webpack_public_path__ + "buying-power-banner.svg?fdc7577c989f6941e6e7d10fec066be6";